import KTag from 'app/components/UI-Elements/DataDisplay/KTag'
import useTranslation from 'app/lib/hooks/useTranslation'
import { RecordTypeEnum } from 'app/queries'
import * as React from 'react'

type Props = {
  member: IProject
}

const stageColor: { [key in IProjectStage]: string } = {
  pending: 'blue',
  realizing: 'green',
  finalized: 'blue',
  canceled: 'default'
}

const ProjectStageTag: React.FC<Props> = ({ member }) => {
  const { tRecordType } = useTranslation({ recordType: RecordTypeEnum.project })

  return (
    <KTag
      text={member.stage ? tRecordType({ id: `stage_info.${member.stage}` }) : '-'}
      color={stageColor[member.stage]}
    />
  )
}

export default ProjectStageTag
